import { logger } from '@/lib/telemetry/logger';

export const fundingAmountStorage = {
  get(key: string): string | null {
    try {
      return typeof window === 'undefined' ? null : window.localStorage.getItem(key);
    } catch {
      logger.warn('onramp.amount_draft_storage_unavailable', { action: 'read' });
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      logger.warn('onramp.amount_draft_storage_unavailable', { action: 'write' });
    }
  },
};
